import React from 'react'
import { Form } from "react-bootstrap"
import Col from "react-bootstrap/Col"


const SelectField = ({name, required, placeholder, values, handlechange, fieldClass, label, grpmd, componentprops, mainClass}) => (
  <Form.Group as={Col} md={grpmd} controlId={`validation${name}`} className={"form-wrap "+mainClass}>
    { label
      ? <Form.Label>{label}{required ? '*' : ''}</Form.Label>
      : ''

    }
    <Form.Control
		className={fieldClass}
		required={required}
		name={name}
		onChange={handlechange}
		as="select"
    value={componentprops ? componentprops[name] : ''}
		>
		{values.map(val =><option value={val} key="">{val}</option>)}
    </Form.Control>
  </Form.Group>

);

export default SelectField;